import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PaymentMethods from "../components/Cards/PaymentMethods";
import CouponModal from "../components/Modal/CounponModal";
import {
  createPayment,
  executePayment,
  initiatePayment,
} from "../api/paymentApi";
import { useAuth } from "../context/AuthContext";
import { createOrder } from "../api/orderApi";
import { createClient } from "../api/clientApi";
import { Bounce, toast } from "react-toastify";
import countriesData from "../data/countries.json";
import { FaCheckCircle } from "react-icons/fa";
import config from "../config";
import { useTranslation } from "react-i18next";
import { MobileCodeSelector } from "../components/Selectors/Country";
// import { createShipment } from "../api/aramexApi";
const COUNTRY_STORAGE_KEY = "selectedCountry";

const getFlagUrl = (countryCode) =>
  `https://flagcdn.com/16x12/${countryCode?.toLowerCase()}.png`;

const getStoredCountry = () => {
  try {
    return localStorage.getItem(COUNTRY_STORAGE_KEY);
  } catch (error) {
    console.error("Error reading country from localStorage:", error);
    return null;
  }
};

const CheckoutPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    isAuthenticated,
    clientData,
    cartTotal,
    selectedBranch,
    setCartTotal,
    setClientData,
    loading,
  } = useAuth();
  const { cart: navCart, total: navTotal } = location.state || {};

  const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
  const storedTotal = parseFloat(localStorage.getItem("cartTotal")) || 0;
  const storedCountry = getStoredCountry();

  const isSameCountry =
  storedCountry?.toLowerCase() ===
  selectedBranch?.country?.toLowerCase();


  const cart = navCart || storedCart;
  const total = navTotal || storedTotal;

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  const [selectPaymentMethod, setSelectPaymentMethod] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState(false);
  const [isCouponModalOpen, setCouponModalOpen] = useState(false);
  const [coupon, setCoupon] = useState(null);
  // Fix: Initialize with dial code instead of country code
  const [mobileCountryCode, setMobileCountryCode] = useState("+974"); // Qatar's dial code
  const [showLoginOption, setShowLoginOption] = useState(false);

  // Guest checkout state
  const isGuest = !clientData;

  const [contact, setContact] = useState({
    username: "",
    email: "",
    mobile: "",
  });

  const [address, setAddress] = useState({
    street: "",
    zone: "",
    city: "",
  });
useEffect(() => {
  const defaultCountry = storedCountry || selectedBranch?.country || "QA";

  const countryData = countriesData.find(
    (country) =>
      country.countryCode.toLowerCase() === defaultCountry?.toLowerCase()
  );

  if (countryData) {
    setMobileCountryCode(`+${countryData.dialCode}`);
  } else {
    setMobileCountryCode("+974");
  }

  // ✅ If logged in → use clientData
  if (clientData) {
    setContact({
      username: clientData.username || "",
      email: clientData.email || "",
      mobile: clientData.mobile || "",
    });

    try {
      const parsedAddress = JSON.parse(clientData.address || "{}");

      setAddress({
        street: parsedAddress?.street || "",
        zone: parsedAddress?.postal_code || "",
        city: parsedAddress?.city || "",
      });
    } catch {
      setAddress({
        street: "",
        zone: "",
        city: "",
      });
    }

    return;
  }

  // ✅ If guest → hydrate from cart storage
  const storedShipping = localStorage.getItem("shippingAddress");

  if (storedShipping) {
    try {
      const parsed = JSON.parse(storedShipping);

      setAddress({
        street: "",
        zone: parsed.postal_code || "",
        city: parsed.city || "",
      });
    } catch (err) {
      console.error("Failed to parse shippingAddress:", err);
    }
  }
}, [clientData, storedCountry, selectedBranch]);
  // useEffect(() => {
  //   if (clientData) {
  //     setContact({
  //       username: clientData.username || "",
  //       email: clientData.email || "",
  //       mobile: clientData.mobile || "",
  //     });
  //     // Fix: Parse stored address if available
  //     try {
  //       const parsedAddress = JSON.parse(clientData.address || "{}");
  //       setAddress({
  //         street: parsedAddress?.street || "",
  //         zone: parsedAddress.postal_code || "",
  //         city: parsedAddress.city || "",
  //       });
  //     } catch (e) {
  //       setAddress({
  //         street: clientData.address || "",
  //         zone: "",
  //         city: "",
  //       });
  //     }
      
  //     // Fix: Set the correct dial code based on stored country or default to Qatar
  //     const defaultCountry = storedCountry || selectedBranch?.country || "QA";
  //     const countryData = countriesData.find((country) =>
  //       country.countryCode.toLowerCase() === defaultCountry.toLowerCase()
  //     );
      
  //     if (countryData) {
  //       setMobileCountryCode(`+${countryData.dialCode}`);
  //     } else {
  //       setMobileCountryCode("+974"); // Default to Qatar
  //     }
  //   } else {
  //     // For guest users, also set default mobile country code
  //     const defaultCountry = storedCountry || selectedBranch?.country || "QA";
  //     const countryData = countriesData.find((country) =>
  //       country.countryCode.toLowerCase() === defaultCountry.toLowerCase()
  //     );
      
  //     if (countryData) {
  //       setMobileCountryCode(`+${countryData.dialCode}`);
  //     } else {
  //       setMobileCountryCode("+974"); // Default to Qatar
  //     }
  //   }
  // }, [clientData, storedCountry, selectedBranch]);

  const getDiscountedTotal = () => {
    if (!coupon) return total;
    if (coupon.discount_type === "percentage") {
      return parseFloat((total * (1 - coupon.discount_value / 100)).toFixed(2));
    } else {
      return parseFloat((total - coupon.discount_value).toFixed(2));
    }
  };

  const discountedTotal = getDiscountedTotal();

  useEffect(() => {
    if (loading) return;
// createShipment('1110');
    // Allow both authenticated and guest users to proceed
    if (!cart || cart.length === 0) {
      navigate("/cart");
      return;
    }

    // If no country is selected, redirect to cart
    if (!storedCountry) {
      toast.error(t("Please select your delivery country first"));
      navigate("/cart");
      return;
    }

    setOrderDetails(null);
    initiatePayments();
  }, [loading, cart, cartTotal, storedCountry]);

  const initiatePayments = () => {
    initiatePayment(
      discountedTotal?.toFixed(2) || "0.00",
      selectedBranch?.currency
    )
      .then((response) => {
        setPaymentMethods(response.Data.PaymentMethods || []);
      })
      .catch((error) => {
        console.error("Error in Initiate Payment:", error);
      });
  };

  const handlePaymentMethod = (method) => {
    console.log("Selected Payment:", method);
    setSelectPaymentMethod(method);
    // toast.success(`${t("PaymentMethodSelected")}: ${method.PaymentMethodEn}`);
  };

  const handlePayment = (orderDetails, payment_id) => {
    setProcessing(true);
    var code = countriesData.filter((option) =>
      option.countryCode
        .toLowerCase()
        .includes(selectedBranch.country.toLowerCase())
    );
    // console.log(code[0].dialCode);
    const mobilecode = "+" + code[0]?.dialCode;

    if (!orderDetails) {
      console.error("Invalid order details");
      setProcessing(false);
      return;
    }

    const paymentDetails = {
      PaymentMethodId: selectPaymentMethod?.PaymentMethodId,
      CustomerName: contact.username,
      DisplayCurrencyIso: selectedBranch?.currency,
      MobileCountryCode: mobilecode,
      CustomerMobile: contact.mobile.replace(mobilecode, ""),
      CustomerEmail: contact.email,
      InvoiceValue: discountedTotal.toFixed(2),
      CallBackUrl: `${config.hostUrl}/paymentsuccess?OrderId=${orderDetails.order.order_id}&isJustView=false&payment_id=${payment_id}`,
      ErrorUrl: `${config.hostUrl}/paymentsuccess?OrderId=${orderDetails.order.order_id}&isJustView=false&payment_id=${payment_id}`,
      Language: "en",
      UserDefinedField: orderDetails.order.order_id,
      CustomerAddress: {
        Block: "",
        Street: address?.street,
        HouseBuildingNo: "",
        Address: address?.postal_code + "," + address?.city,
        AddressInstructions: "",
      },
    };

    // Fix: Better error handling and timeout for payment execution
    const paymentTimeout = setTimeout(() => {
      toast.error(t("Payment request timed out. Please try again."));
      setProcessing(false);
      setPaymentFailed(true);
    }, 30000); // 30 second timeout

    executePayment(paymentDetails)
      .then((response) => {
        clearTimeout(paymentTimeout);
        
        console.log("Payment Response:", response); // Debug log
        
        if (response && response.IsSuccess) {
          const paymentUrl = response.Data?.PaymentURL;
          if (paymentUrl) {
            // Clear cart only after successful payment URL generation
            localStorage.removeItem("cart");
            setCartTotal(0);
            
            // Add a small delay to ensure state is updated
            setTimeout(() => {
              window.location.href = paymentUrl;
            }, 100);
          } else {
            toast.error(t("PaymentURLismissing"));
            setProcessing(false);
            setPaymentFailed(true);
          }
        } else {
          const errorMessage = response?.ValidationErrors?.[0]?.Error || 
                              response?.Data?.ErrorMessage || 
                              response?.Message || 
                              t("Paymentfailed");
          toast.error(errorMessage);
          setProcessing(false);
          setPaymentFailed(true);
        }
      })
      .catch((error) => {
        clearTimeout(paymentTimeout);
        console.error("Payment execution error:", error);
        
        const errorMessage = error?.response?.data?.message || 
                            error?.message || 
                            t("Payment request failed. Please try again.");
        toast.error(errorMessage);
        setProcessing(false);
        setPaymentFailed(true);
      });
  };

  const handlePlaceOrder = async () => {
    if (!selectPaymentMethod) {
      toast.error(t("Pleaseselectapaymentmethod"));
      return;
    }

    // Validate required fields
    if (!contact.username || !contact.email || !contact.mobile) {
      toast.error(t("Please fill in all contact information"));
      return;
    }

    if (!address.street || !address.zone || !address.city) {
      toast.error(t("Please fill in all address information"));
      return;
    }

    setProcessing(true);
    try {
      let currentClientData = clientData;

      // Create guest user if not authenticated
      if (isGuest) {
        const generatedPassword = Math.random().toString(36).slice(-10) + "!A1";

        try {
          const newClient = await createClient({
            username: contact.username,
            email: contact.email,
            password: generatedPassword,
            country: storedCountry,
            mobile: mobileCountryCode + contact.mobile,
            address: address.street,
            date_created: new Date(),
          });

          setClientData(newClient);
          currentClientData = newClient;

          // toast.success(t("Account created successfully! You can login with your email and password: ") + generatedPassword, {
          //   position: "top-center",
          //   autoClose: 8000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light",
          //   transition: Bounce,
          // });
        } catch (error) {
          toast.error(t("Failed to create account: ") + error.message);
          setProcessing(false);
          return;
        }
      }

      const discountValue = coupon
        ? parseFloat((total - getDiscountedTotal()).toFixed(2))
        : 0;

      const myorder = {
        branch_id: selectedBranch?.branch_id,
        client_id: currentClientData?.client_id,
        shipping_address: address,
        shipping_cost: cart[0]?.delivery_cost || 0,
        items: cart.map((item) => ({
          product_id: item.product_id,
          quantity: item.quantity,
          price: item.price,
        })),
        coupon_id: coupon?.coupon_id,
        discount: discountValue,
        total: discountedTotal,
      };

      const response = await createOrder(myorder);
      setOrderDetails(() => response);

      const paymentResponse = await createPayment({
        order_id: response.order.order_id,
        amount: total,
        payment_method:
          selectPaymentMethod?.PaymentMethodId === 100
            ? "cash_delivery"
            : selectPaymentMethod?.PaymentMethodId === 6
            ? "debit_card"
            : "credit_card",
        payment_status: "Pending",
      });

      // For cash on delivery, clear cart and navigate to orders
      if (selectPaymentMethod?.PaymentMethodId === 100) {
        // createShipment(response.order.order_id);
        localStorage.removeItem("cart");
        setCartTotal(0);
        navigate("/orders");
        return;
      }

      // For online payments, handle payment execution first
      // Only clear cart after successful payment execution
      handlePayment(response, paymentResponse?.payment?.payment_id);
      
    } catch (error) {
      toast.error(error.message || error, {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setOrderDetails(null);
      setProcessing(false);
      return;
    }
  };

  const handleCouponConfirm = (coupon) => {
    console.log("Confirmed Coupon:", coupon);
    localStorage.setItem("coupon", JSON.stringify(coupon));
    setCoupon(coupon);
  };

  const getCountryName = (countryCode) => {
    const country = countriesData.find(
      (c) => c.countryCode.toLowerCase() === countryCode?.toLowerCase()
    );
    return country?.countryName || countryCode;
  };



  return (
    <div className="max-w-6xl mx-auto p-6 grid md:grid-cols-3 gap-6">
      {/* Left Section - Form */}
      <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold mb-4">{t("Checkout")}</h2>

        {/* Guest/Login Section */}
        {isGuest && (
          <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <div className="flex items-center justify-between">
              <span className="text-sm text-blue-800">
                {t("Checkout as guest or login to your account")}
              </span>
              <button
                onClick={() => navigate("/login")}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-700"
              >
                {t("Login")}
              </button>
            </div>
          </div>
        )}

        {/* Contact Information */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold">{t("ContactInformation")}</h3>
          <input
            type="text"
            placeholder={t("name")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={contact.username}
            required
            onChange={(e) =>
              setContact({ ...contact, username: e.target.value })
            }
          />
          <input
            type="email"
            placeholder={t("email")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={contact.email}
            required
            onChange={(e) => setContact({ ...contact, email: e.target.value })}
          />
          <div className="mt-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2 gap-1">
            <div className="w-[35%]">
              <MobileCodeSelector
                value={mobileCountryCode}
                onChange={(selectedCode) => {
                  console.log("Selected mobile code:", selectedCode); // Debug log
                  setMobileCountryCode(selectedCode);
                }}
                name="mobileCountryCode"
              />
            </div>

            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder={t("mobile")}
              className=" border p-3 rounded-lg "
              value={contact.mobile}
              required
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/\D/g, ""); // Remove non-numeric
                setContact({ ...contact, mobile: onlyNumbers });
              }}
            />
          </div>
        </div>

        {/* Delivery Address */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold">{t("DeliveryAddress")}</h3>

          {/* Country Display with Update Button */}
          <div className="mb-4 p-3 bg-gray-50 rounded-lg border">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">
                  {t("Delivery Country")}:
                </span>
                <img
                  src={getFlagUrl(storedCountry)}
                  alt={`flag of ${storedCountry}`}
                  style={{ width: "16px", height: "auto" }}
                />
                <span className="font-medium">
                  {getCountryName(storedCountry)}
                </span>
              </div>
              <button
                onClick={() => navigate("/cart")}
                className="bg-gray-600 text-white px-3 py-1 rounded text-sm hover:bg-gray-700"
              >
                {t("Update Country")}
              </button>
            </div>
          </div>

          <input
            type="text"
            placeholder={t("StreetAddress")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={address.street}
            required
            onChange={(e) => setAddress({ ...address, street: e.target.value })}
          />
          <input
            type="text"
            placeholder={t("Zone")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={address.zone}
            required
            onChange={(e) => setAddress({ ...address, zone: e.target.value })}
          />
          <input
            type="text"
            placeholder={t("City")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={address.city}
            required
            onChange={(e) => setAddress({ ...address, city: e.target.value })}
          />
        </div>

        {/* Payment Methods */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold">{t("selectpaymethod")}</h3>
          <PaymentMethods
            paymentMethods={paymentMethods}
            handlePayment={handlePaymentMethod}
            isCOD={isSameCountry}
          />
        </div>
      </div>

      {/* Right Section - Order Summary */}
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold mb-4">{t("OrderSummary")}</h2>

        {cart && cartTotal > 0 ? (
          <>
            {cart.map((item) => (
              <div key={item.product_id} className="flex justify-between py-2">
                <span>
                  {item.name} (x{item.quantity})
                </span>
                <span>
                  {(item.price * item.quantity).toFixed(2)}{" "}
                  {selectedBranch?.currency}
                </span>
              </div>
            ))}
            <div className="mt-6 text-sm divide-y">
              <span>{t("discount")}</span>{" "}
              <button
                onClick={() => {
                  setCoupon(null);
                  setCouponModalOpen(true);
                }}
                className="bg-blue-300 rounded-full px-2 py-1 w-full text-center text-black font-extrabold"
              >
                {coupon
                  ? coupon.discount_type === "percentage"
                    ? `${coupon.discount_value}%`
                    : `${coupon.discount_value}`
                  : t("applycoupon")}
              </button>
            </div>
            <div className="mt-6 text-sm border divide-y">
              <div className="flex justify-between">
                <span>{t("Delivery")}:</span>
                <span>
                  {cart[0]?.delivery_cost || "0.00"} {selectedBranch?.currency}
                </span>
              </div>
            </div>
            <div className="flex justify-between">
              <span>{t("Total")}:</span>
              <span>
                {coupon && total !== discountedTotal && (
                  <span className="line-through text-gray-400 mr-2">
                    {total.toFixed(2)}
                  </span>
                )}
                <span>
                  {discountedTotal.toFixed(2)} {selectedBranch?.currency}
                </span>
              </span>
            </div>

            <CouponModal
              isOpen={isCouponModalOpen}
              onClose={() => setCouponModalOpen(false)}
              onConfirm={handleCouponConfirm}
            />

            {orderDetails && paymentFailed ? (
              <div className="mt-6 w-full">
                <div className="flex justify-center items-center space-x-2">
                  <FaCheckCircle color="green" />
                  <span>
                    {t("OrderID")}: {orderDetails?.order?.order_id}
                  </span>
                </div>
                <div className="flex justify-center items-center space-x-2 w-full">
                  <Link
                    to="/orders"
                    className="mt-6 text-center w-full bg-green-800 text-white py-3 rounded-lg font-semibold hover:bg-green-700"
                  >
                    {t("MyOrders")}
                  </Link>
                </div>
                <button
                  className="mt-6 w-full bg-slate-900 text-white py-3 rounded-lg font-semibold hover:bg-slate-700"
                  onClick={() => handlePayment(orderDetails)}
                  disabled={!selectPaymentMethod || processing}
                >
                  {processing ? t("Processing") : t("RetryPayment")}
                </button>
              </div>
            ) : (
              <button
                className="mt-6 w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700"
                onClick={handlePlaceOrder}
                disabled={cartTotal === 0 || processing}
              >
                {processing ? t("Processing") : t("paynow")}
              </button>
            )}
          </>
        ) : (
          <div>{t("cart.empty")}</div>
        )}
      </div>
    </div>
  );
};

export default CheckoutPage;